import { mapActions } from "vuex";
import moment from "moment";
export default {
    name: "outBillOrderList",
    data() {
        return {
            permissions: {
                Over_Export: false,      //导出
                Over_Sure: false,        //确认账单
                OverQueryDetail: false,  //查看明细
                OverExportDetail: false, //导出明细
                Over_Query: false        //查询
			},
            // show: {
            //     Over_Export: false,
            //     Over_Sure: false,
            // },
            outBill: {
                billDate: [],
                billState: null,
            },
            /* 账单状态(1-未对账、2-已对账、3-扣款中、4-付款中、5-已结清、6-已废弃) */
            billStateList: [
                {
                    value: null,
                    label: '全部'
                },
                {
                    value: 1,
                    label: '未对账'
                },
                {
                    value: 2,
                    label: '已对账'
                },
                {
                    value: 3,
                    label: '扣款中'
                },
                {
                    value: 4,
                    label: '付款中'
                },
                {
                    value: 5,
                    label: '已结清'
                },
                {
                    value: 6,
                    label: '已废弃'
                },
            ],
            pageLoading: false,
            showOutBillInfo: false,
            pageData: [],
            pageBase: {
                pageSizes: [10, 20, 30, 40, 50, 100],
                pageSize: 10,
                pageNumber: 1,
                total: 0
            },
            tableColunm: [
                {
                    prop: 'billMonth',
                    label: '账单月份',
                    width: 140
                },
                {
                    prop: 'billNo',
                    label: '账单编号',
                    width: 300
                },
                /* 账单状态(1-未对账、2-已对账、3-扣款中、4-付款中、5-已结清、6-已废弃) */
                {
                    label: '账单状态',
                    width: 120,
                    formatter: function (row, column) {
                        if (row.billStatus == 1) {
                            return '未对账';
                        } else if (row.billStatus == 2) {
                            return '已对账';
                        } else if (row.billStatus == 3) {
                            return '扣款中';
                        } else if (row.billStatus == 4) {
                            return '付款中';
                        } else if (row.billStatus == 5) {
                            return '已结清';
                        } else if (row.billStatus == 6) {
                            return '已废弃';
                        }
                        return null;
                    }
                },
                {
                    prop: 'amount',
                    label: '合计应付（含税:元）',
                    width: 180,
                    formatter: function (row, column) {
                        return row.amount;
                    }
                },
                {
                    prop: 'oppositeUserName',
                    label: '货主名称',
                },

                {
                    prop: 'ownUserName',
                    label: '签约主体',
                },
                {
                    prop: 'contractCode',
                    label: '合同编号',
                },
            ]
        }
    }, methods: {
        ...mapActions([
            "queryBillData",
            "getRowInfo",
            "affirmOrder",
            "uploadTOdown"
        ]),
        affirmRow(row) {
            let param = {
                "billNo": row.billNo
            }
            this.affirmOrder(param).then(res => {
                if (res != false) {
                    this.$notify({
                        type: 'success',
                        title: '提示',
                        dangerouslyUseHTMLString: true,
                        message: '操作成功！',
                        duration: 5000
                    });
                }
                setTimeout(()=>{
                    this.queryOutbillPage();
                },300)
            }).catch(e => { });
        },
        getRowInfo(row) {
            window.sessionStorage.setItem('outBillRowData', JSON.stringify(row))
            this.$router.push('/manage/OverBillInfo')
        },
        exportOutbillShipInfo2() {
            if (!document.getElementById('orderFile').files[0]) {
                this.$message({
                    type: "error",
                    message: '请选择文件！'
                });
                return;
            }
            this.uploadUsualLineLoading = true;
            let formData = new window.FormData();
            if (document.getElementById('orderFile').files[0]) {
                formData.append('cmFile', document.getElementById('orderFile').files[0]);
            }
        },
        queryOutbillPage() {
            this.pageBase.pageNumber = 1;
            this.queryPageBase();
        },
        queryPageBase() {
            let startMonth = "";
            let endMonth = "";
            if (!this.outBill.billDate || this.outBill.billDate.length < 1) {
                this.$message({
                    type: "error",
                    message: '账单日不能为空'
                });
                return;
            }
            startMonth = moment(new Date(this.outBill.billDate[0])).format("YYYY-MM");
            endMonth = moment(new Date(this.outBill.billDate[1])).format("YYYY-MM");

            let time = new Date(endMonth).getTime() - new Date(startMonth).getTime();
            let split = time / (24 * 3600 * 1000);
            if (split > 365) {
                this.$message({
                    type: "error",
                    message: '账单日查询区间不能超过1年'
                });
                return;
            }

            let param = {
                "billStatus": this.outBill.billState,
                "billMonthBegin": startMonth,
                "billMonthEnd": endMonth,
                "pageSize": this.pageBase.pageSize,
                "pageNumber": this.pageBase.pageNumber
            }
            this.queryBillData(param).then(res => {
                this.pageData = res.dataList;
                this.pageBase.total = res.totalSize;

            }).catch(e => { });
        },
        exportOutbillShip() {
            let startMonth = "";
            let endMonth = "";
            if (this.outBill.billDate && this.outBill.billDate.length > 1) {
                startMonth = moment(new Date(this.outBill.billDate[0])).format("YYYY-MM");
                endMonth = moment(new Date(this.outBill.billDate[1])).format("YYYY-MM");
            }
            let param = {
                "billStatus": this.outBill.billState,
                "billMonthBegin": startMonth,
                "billMonthEnd": endMonth,
                "pageSize": 10000,
                "pageNumber": 1
            }

            this.uploadTOdown(param).then(res => {
                window.open(this.getHostUrl() + "/saas/shipperOrderController/downLoadFile?objectName=" + res)
            }).catch(e => {

            });
        },
        getHostUrl() {
            return location.protocol + "//" + location.host;
        },
        clearOjb() {
            this.outBill.billState = null;
            this.getTimeInit();
        },
        selectionChange(val) {
            this.multipleSelection = val;
        },
        rowDblclick(row) {
            //
        },
        sizeChange(val) {
            this.pageBase.pageSize = val;
            this.pageBase.pageNumber = 1;
            this.queryPageBase();
        },
        currentChange(val) {
            this.pageBase.pageNumber = val;
            this.queryPageBase();
        },
        getTimeInit() {
            let start = new Date(new Date().getTime() - 32 * 24 * 60 * 60 * 1000);
            let end = new Date(new Date().getTime() + 15 * 24 * 60 * 60 * 1000);
            this.outBill.billDate = [start, end]
        }
    }, created: function () {
        this.getTimeInit();
        // let menuInterval = setInterval(() => {
        //     let map = JSON.parse(sessionStorage.getItem('menuMap'))
        //     if (map) {
        //         clearInterval(menuInterval)
        //         let submenuList = map['OverBill'].split('-');
        //         submenuList.forEach((item, i) => {
        //             this.show[item] = true;
        //         });
        //     }
        // }, 30);
        this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
        this.queryOutbillPage() 
    }
};